module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "infoMenu"
  }, [(_vm.bugReport) ? _c('modal', [_c('div', {
    slot: "header"
  }, [_vm._v("Beskriv en bugg eller din synpunkt nedan.")]), _vm._v(" "), _c('div', {
    slot: "body"
  }, [_c('textarea', {
    attrs: {
      "id": "bugreport-text"
    }
  })]), _vm._v(" "), _c('div', {
    slot: "footer"
  }, [_c('div', {
    staticClass: "modal-button",
    on: {
      "click": function($event) {
        _vm.$store.commit('showBugReport', false)
      }
    }
  }, [_vm._v("Avbryt")]), _vm._v(" "), _c('div', {
    staticClass: "modal-button",
    on: {
      "click": _vm.reportABug
    }
  }, [_vm._v("Skicka")])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "inside-closer",
    on: {
      "click": function($event) {
        _vm.$store.commit('showInfoMenu', false)
      }
    }
  }, [_vm._v("✖")]), _vm._v(" "), _c('div', {
    staticClass: "menu-header"
  }, [_vm._v("General")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "list-item",
    on: {
      "click": function($event) {
        _vm.$store.commit('showBugReport', true)
      }
    }
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("Hör av dig")]), _vm._v(" "), _c('div', {
    staticClass: "subtitle"
  }, [_vm._v("Skicka en bugg eller andra synpunkter på spelet!")])]), _vm._v(" "), _vm._l((_vm.list), function(listItem) {
    return _c('div', {
      staticClass: "list-item"
    }, [_c('div', {
      staticClass: "title"
    }, [_vm._v(_vm._s(listItem.title))]), _vm._v(" "), _c('div', {
      staticClass: "subtitle"
    }, [_vm._v(_vm._s(listItem.subtitle))])])
  })], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "list-item",
    attrs: {
      "href": "https://game.exhibitionstockholm.se"
    }
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("Start")]), _vm._v(" "), _c('div', {
    staticClass: "subtitle"
  }, [_vm._v("Gå till startsidan")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "list-item",
    attrs: {
      "href": "https://game.exhibitionstockholm.se/#/tutorial"
    }
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("Guide")]), _vm._v(" "), _c('div', {
    staticClass: "subtitle"
  }, [_vm._v("Gå till startguiden")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "list-item",
    attrs: {
      "href": "https://helpx.adobe.com/lightroom/how-to/lightroom-mobile.html",
      "target": "_blank"
    }
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("Lightroom Mobile")]), _vm._v(" "), _c('div', {
    staticClass: "subtitle"
  }, [_vm._v("Kom igång med Lightroom Mobile")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5c39fb36"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/infoMenu.vue
// module id = 116
// module chunks = 0